module.exports = __webpack_public_path__ + "img/Sylva_closed.e19a119f.png";